import React, { ReactElement } from "react";
import { Stack } from "sprint-common-web";

import { AssetTypeBadge } from "../components/AssetTypeBadge";
import { AssetType } from "../types/AssetType";

export const renderAssetType = ({
    assetType,
    testId
}: {
    assetType?: AssetType;
    testId?: string;
}): ReactElement | null => {
    if (!assetType) return null;

    return <AssetTypeBadge value={assetType} testId={testId} />;
};

export const renderAssetTypes = (item?: { types?: AssetType[] }): ReactElement | null => {
    const { types } = item || {};
    if (!types || types.length === 0) {
        return null;
    }

    return (
        <Stack tokens={{ childrenGap: 5 }} data-testId="asset-type">
            {types.map((type) => (
                <AssetTypeBadge key={type} value={type} />
            ))}
        </Stack>
    );
};
